import { Bell } from 'lucide-react';
import { requestPermission } from '@/lib/notifications';
import { useToast } from '@/hooks/useToast';

interface NotificationPermissionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NotificationPermissionModal({
  isOpen,
  onClose,
}: NotificationPermissionModalProps) {
  const { toast } = useToast();

  if (!isOpen) return null;

  const handleEnable = async () => {
    const result = await requestPermission();
    if (result === 'denied') {
      toast('Notifications blocked. Enable in browser settings.', 'error');
    }
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className="w-full max-w-sm rounded-2xl p-6"
        style={{ background: 'var(--color-surface)' }}
      >
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
          style={{ background: 'rgba(212,168,75,0.15)' }}
        >
          <Bell size={32} style={{ color: 'var(--color-primary)' }} />
        </div>
        <h2
          className="text-xl font-bold text-center mb-2"
          style={{ color: 'var(--color-text)' }}
        >
          Stay on schedule
        </h2>
        <p
          className="text-sm text-center mb-6"
          style={{ color: 'var(--color-text-muted)' }}
        >
          Get notified 10 minutes before each event — without opening the app.
        </p>
        <button
          onClick={handleEnable}
          className="w-full h-12 rounded-xl font-semibold text-base cursor-pointer"
          style={{ background: 'var(--color-primary)', color: '#1A1A2E' }}
        >
          Enable Notifications
        </button>
        <button
          onClick={onClose}
          className="w-full mt-3 text-sm text-center cursor-pointer"
          style={{ color: 'var(--color-text-muted)', background: 'transparent', border: 'none' }}
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
}
